<template>

    <div class="wrapper">

        <section class="intro politica column-center">

            <h1 class="big-title column-center">
                <span>Declaración de accesibilidad</span>
            </h1>

        </section>


        <section class="breadcrumb">
            <nav class="container row-start">
                <router-link to="/">Home</router-link>
                <a>Accesibilidad</a>
            </nav>
        </section>


        <section class="contenedor-accesibilidad">
            <div class="container">
                <h2>Declaración de accesibilidad</h2>
                <p>
                    Diputación Provincial de Jaén se ha comprometido a hacer accesibles sus sitios web de conformidad
                    con el Real Decreto 1112/2018, de 7 de septiembre, sobre accesibilidad de los sitios web y
                    aplicaciones para dispositivos móviles del sector público (<a target="_blank"
                        href="https://www.boe.es/buscar/act.php?id=BOE-A-2018-12699">Consultar norma completa</a>)
                </p>
                <p>
                    La presente declaración de accesibilidad se aplica al sitio ajaen.jaenparaisointerior.es

                </p>
                <h2>Situación de cumplimiento</h2>
                <p>Este sitio web resulta plenamente conforme con el Real Decreto 1112/2018 alcanzando el nivel AA
                    previsto por la normativa.</p>
                <h2>Contenido no accesible</h2>
                <p>
                    El sitio web cumple todos los requisitos de la norma UNE-EN 301 549:2022 excluyendo el contenido
                    excluido por el RD 1112/2018.
                </p>
                <p>
                    Los ficheros PDF históricos están excluidos, pero a partir de 30/12/2022, se crearán conforme a la
                    norma.
                </p>
                <h2>Carga desproporcionada.</h2>
                <p>
                    No aplica.
                </p>
                <h2>
                    Preparación de la presente declaración de accesibilidad
                </h2>
                <p>
                    Esta declaración de accesibilidad se preparó el 30 de diciembre de 2022.
                </p>
                <p>
                    El método de evaluación de la accesibilidad empleado para preparar la declaración de acuerdo con el
                    artículo 3 de la Decisión de Ejecución (UE) 2018/1523 ha aplicado una evaluación manual y
                    automática, llevada a cabo por un tercero cumpliendo la medición de los requisitos expuestos en el
                    artículo 17.5 del RD 1112/2018.
                </p>
                <h2>
                    Observaciones y datos de contacto
                </h2>
                <p>
                    Puede realizar comunicaciones sobre requisitos de accesibilidad (artículo 10.2.a) del Real Decreto
                    1112/2018, de 7 de septiembre) como, por ejemplo:

                </p>
                <ul>
                    <li>Informar sobre cualquier posible incumplimiento por parte de este sitio web.</li>
                    <li>Transmitir otras dificultades de acceso al contenido.</li>
                    <li>Formular cualquier otra consulta o sugerencia de mejora relativa a la accesibilidad del sitio
                        web.</li>
                </ul>
                <p>
                    Para ello dispone de este  formulario de contacto o bien del teléfono 953 24 80 00 ext. 1270.
                </p>
                <p>
                    De igual forma dispone del trámite para la formulación de quejas y solicitud de información
                    accesible, según la normativa aplicable a los mismos (art. 12. RD 1112/2018).
                </p>
                <p><a href="https://sede.dipujaen.es/QuejasSugerencias" target="_blank">Acceso al trámite </a></p>
                <p>La Solicitud de Información Accesible se contempla para los siguientes casos:</p>
                <ul>
                    <li>contenidos que están excluidos del ámbito de aplicación del RD 1112/2018 según lo establecido
                        por el artículo 3, apartado 4.</li>
                    <li>contenidos que están exentos de cumplimiento de los requisitos de accesibilidad por imponer una
                        carga desproporcionada.</li>
                </ul>
                <p>
                    En la solicitud de información accesible, se debe concretar, con toda claridad, los hechos, razones
                    y petición que permitan constatar que se trata de una solicitud razonable y legítima.
                </p>
                <p>
                    Las comunicaciones, quejas y solicitudes de información accesible serán recibidas por Diputación
                    Provincial de Jaén.
                </p>
                <p>
                     Diputación Provincial de Jaén trabaja para garantizar que todos los ciudadanos, -con especial
                    atención a las personas con algún tipo de discapacidad y mayores-, que se relacionen con Diputación
                    de Jaén a través de los portales webs y sedes electrónicas impulsados por la institución provincial
                    puedan acceder a la información y los servicios electrónicos en igualdad de condiciones, con
                    independencia de sus circunstancias personales, medios y conocimientos.  

                </p>
            </div>
        </section>
    </div>

</template>

<script>

import { mapGetters } from 'vuex';

export default {
    name: 'accesibilidad',
    computed: {
        ...mapGetters({
            categorias: 'getCategorias'
        })
    },
}
</script>


// WEBPACK FOOTER //
// src/components/views/accesibilidad.vue